import api from '../../Api';
import Cookies from 'universal-cookie';

const cookies = new Cookies;

interface IClienteRepositorio {
    getAll: Function
    get: Function
    add: Function
    update: Function
    getSearchField: Function
}

const clienteRepositorio: IClienteRepositorio = {
    getAll: async () => {
        const response = await api.get('/cliente', {
            headers: {
                Authorization: 'Bearer ' + cookies.get('token')
            }
        });
        return response;
    },
    get: async (idcliente: number) => {
        const response = await api.get('/cliente/' + idcliente, {
            headers: {
                Authorization: 'Bearer ' + cookies.get('token')
            }
        });
        return response;
    },
    add: async (dtocliente: any) => {
        const response = await api.post('/cliente', dtocliente, {
            headers: {
                Authorization: 'Bearer ' + cookies.get('token')
            }
        });
        return response;
    },
    update: async (dtocliente: any) => {
        const response = await api.put('/cliente/' + dtocliente.idcliente, dtocliente, {
            headers: {
                Authorization: 'Bearer ' + cookies.get('token')
            }
        });
        return response;
    },
    getSearchField: async () => {
        const response = await api.get('/cliente', {
            headers: {
                Authorization: 'Bearer ' + cookies.get('token')
            }
        });
        const listaClientes = response.data.map((item: any) => {
            return {
                label: item.nome,
                value: item.idcliente
            }
        })
        return listaClientes;
    }
}

export default clienteRepositorio;